{
  "hero": {
    "eyebrow": "About us",
    "title": "We build energy-fintech solutions to accelerate",
    "highlight": "the energy transition",
    "lede": "We create cutting-edge products designed to manage the growing complexity of the renewable energy sector, making it more efficient, accessible and profitable."
  },
  "milestones": {
    "eyebrow": "Our journey",
    "heading": "The DEC Energy story",
    "founded": {
      "title": "Company founded in Lugano"
    },
    "venture": {
      "title": "Top 3 fintech startup in Switzerland",
      "source": "by >>venture>>"
    },
    "climate": {
      "month": "March",
      "title": "Top 10 climate software company in Europe",
      "source": "by Energy Tech Challengers"
    },
    "energyFintech": {
      "month": "October",
      "title": "Best fintech tool for renewable energy production and consumption",
      "source": "by Fintech Awards Italia"
    }
  },
  "founders": {
    "eyebrow": "Innovation",
    "heading": "The founders",
    "linkedinLabel": "{{name}}'s LinkedIn profile",
    "photoAlt": "The founders of DEC Energy",
    "roles": ["CEO and Co-Founder", "COO and Co-Founder"]
  },
  "partners": {
    "eyebrow": "Who we work with",
    "heading": "Partnering with leading companies in renewable energy and beyond"
  },
  "team": {
    "eyebrow": "Join us",
    "heading": "Are you our next great hire?",
    "body": "We're always looking for talent. Send us your CV along with a cover letter and let's talk.",
    "cta": "Apply here",
    "photoAlt": "The DEC Energy team"
  },
  "ctaTitle": "Want to learn more about DEC Energy?",
  "committee": {
    "eyebrow": "Strategic and operations committee",
    "heading": "Supported by industry experts",
    "label": "Committee",
    "linkedinLabel": "{{name}}'s LinkedIn profile"
  }
}
